import type { Dispatch } from 'redux';
import { connect } from '@atlassian/jira-react-redux';
import { FETCH_COMPONENTS_REASON } from '../../common/constants/fetch-components-reason';

import type { OrderField, OrderDirection } from '../../query-param-adapter/model/order';
import { getComponentsPageRequest } from '../../state/actions';

import { getIds as getComponentIds } from '../../state/components/selectors';
import { isAdmin } from '../../state/context/selectors';
import { patchQuery } from '../../state/query/actions';
import { getOrderDirection, getOrderField } from '../../state/query/selectors';
import type { State } from '../../state/reducer';
import { isLoading as isPageLoading } from '../../state/ui/page/selectors';

import TableView from './view';

const mapStateToProps = (state: State) => ({
	componentIds: getComponentIds(state),
	isLoading: isPageLoading(state),
	editable: isAdmin(state),
	orderField: getOrderField(state),
	orderDirection: getOrderDirection(state),
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
	onSort: ({ key, sortOrder }: { key: OrderField; sortOrder: OrderDirection }) => {
		dispatch(
			patchQuery({
				orderDirection: sortOrder,
				orderField: key,
				page: 1,
			}),
		);
		dispatch(
			getComponentsPageRequest({
				page: 1,
				initiatedBy: FETCH_COMPONENTS_REASON.SORTING,
			}),
		);
	},
});

export default connect(mapStateToProps, mapDispatchToProps)(TableView);
